
const translation = {
  nav_used_pallets: "Palettes Usagées",
  nav_new_pallets: "Palettes Neuves",
  nav_services: "Services",
  nav_about: "À Propos",
  nav_faq: "FAQ",
  nav_contact: "Contact",
  nav_get_quote: "Devis",

  hero_location: "Anvers, Belgique",
  hero_title_line1: "PALETTES",
  hero_title_line2: "EURO PREMIUM",
  hero_subtitle: "Fournisseur fiable de palettes usagées Grade A, Grade B et palettes en bois neuves. Contrôle qualité. Livraison rapide en Belgique.",
  hero_cta_quote: "Demander un Devis",
  hero_cta_products: "Voir les Produits",

  stat_years: "Ans d'Expérience",
  stat_pallets: "Palettes Livrées",
  stat_grades: "Grades de Produits",
  stat_quality: "Contrôle Qualité",

  gallery_label: "La Qualité Visible",
  gallery_title: "Notre Collection de Palettes",
  gallery_grade_a: "Grade A Premium",
  gallery_grade_b: "Grade B Économique",
  gallery_new: "Palettes Neuves",
  gallery_custom: "Commandes Spéciales",

  how_label: "Processus Simple",
  how_title: "Comment Ça Marche",
  how_subtitle: "De la navigation à la livraison, nous rendons la commande de palettes rapide et simple.",
  how_step1_title: "Parcourir & Sélectionner",
  how_step1_desc: "Explorez notre gamme de palettes Grade A, Grade B et neuves. Consultez les spécifications détaillées et les photos.",
  how_step2_title: "Demande de Devis / Commande",
  how_step2_desc: "Soumettez une demande de devis ou passez une commande directe en ligne. Nous confirmons sous 24 heures.",
  how_step3_title: "Livraison Rapide",
  how_step3_desc: "Recevez vos palettes rapidement en Belgique et en Europe. Toutes les commandes sont vérifiées avant expédition.",

  used_label: "Palettes Usagées de Qualité",
  used_title: "Palettes Euro Usagées",
  used_subtitle: "Choisissez entre Grade A premium ou Grade B économique. Toutes inspectées et prêtes à l'emploi.",

  new_label: "Palettes Toutes Neuves",
  new_title: "Palettes en Bois Neuves",
  new_subtitle: "Palettes certifiées ISPM15, prêtes à l'export, fabriquées selon les normes les plus élevées. Tailles personnalisées disponibles.",

  product_quick_specs: "Spécifications Rapides",
  product_dimensions: "Dimensions",
  product_load: "Capacité de Charge",
  product_wood: "Type de Bois",
  product_order_now: "Commander",
  product_view_details: "Voir Détails",
  product_view_angles: "Vues & Détails",
  product_tech_specs: "Spécifications Techniques",
  product_key_features: "Caractéristiques Clés",
  product_request_quote: "Demander un Devis pour ce Produit",
  product_call_us: "Nous Appeler",

  calc_current_price: "Prix Actuel",
  calc_volume_hint: "Tarifs dégressifs disponibles – commandez plus pour économiser !",
  calc_total_price: "Prix Total",
  calc_price_per: "Prix par palette",
  calc_quantity: "Quantité",
  calc_pallets: "palettes",
  calc_order_now: "Commander",
  calc_current_selection: "Sélection Actuelle",
  calc_pieces: "pièces",
  calc_per_pallet: "par palette",
  calc_calculate: "Calculer Votre Commande",
  calc_payment_methods: "MÉTHODES DE PAIEMENT DISPONIBLES",
  calc_volume_pricing: "Tarifs Dégressifs",
  calc_bulk_discount: "Remise volume appliquée",
  calc_min_order: "Commande minimum : 10 palettes",
  calc_payment_methods_label: "Méthodes de paiement :",
  calc_total: "Total :",
  calc_select_qty: "Sélectionner Quantité & Paiement",
  calc_total_price_label: "Prix Total",

  services_label: "Ce Que Nous Faisons",
  services_title: "Nos Services",
  services_subtitle: "Du tri à la livraison, nous fournissons des solutions complètes de palettes pour votre entreprise.",
  service1_title: "Tri & Classement des Palettes",
  service1_desc: "Inspection manuelle experte et classement de chaque palette.",
  service2_title: "Approvisionnement en Gros",
  service2_desc: "Commandes en grande quantité bienvenues. Prix compétitifs pour les achats en gros.",
  service3_title: "Commandes Personnalisées",
  service3_desc: "Besoin de tailles non standard ? Nous fabriquons des palettes sur mesure.",
  service4_title: "Livraison Rapide",
  service4_desc: "Livraison fiable en Belgique et en Europe.",

  quality_label: "Nos Standards",
  quality_title: "Système de Grades de Qualité",
  quality_subtitle: "Chaque palette est soigneusement inspectée et classée selon les normes européennes strictes.",
  grade_a_label: "Grade Premium",
  grade_b_label: "Grade Standard",
  grade_new_label: "Toute Neuve",

  about_label: "Qui Nous Sommes",
  about_title: "Le Partenaire Palette de Confiance d'Anvers",
  about_p1: "PEL Partner Company est un fournisseur de palettes Euro basé à Anvers, Belgique. Nous fournissons des entreprises en Belgique et en Europe avec des palettes de haute qualité.",
  about_p2: "Que vous ayez besoin de palettes Grade A premium, Grade B économiques ou de palettes neuves pour l'export — nous avons la bonne solution au bon prix.",
  about_location: "Anvers, Belgique",
  about_quality: "Chaque palette inspectée",
  about_delivery: "Rapide en Belgique",
  about_support: "Lun–Ven 8:00–18:00",
  about_years: "Ans d'Activité",
  about_supplied: "Palettes Fournies",

  videos_label: "Voyez-le en Action",
  videos_title: "Nos Opérations",
  videos_subtitle: "Regardez comment nous trions, inspectons et préparons les palettes.",
  tab_sorting: "Processus de Tri",
  tab_quality: "Contrôle Qualité",
  tab_delivery: "Livraison",
  video_sorting_title: "Tri & Inspection Manuels",
  video_sorting_desc: "Chaque palette est vérifiée manuellement pour la qualité",
  video_strict: "Inspection Stricte",
  video_strict_desc: "Chaque palette est inspectée manuellement pour l'intégrité structurelle et la conformité EPAL.",
  video_sorted: "Trié par Grade",
  video_sorted_desc: "Les palettes sont soigneusement triées en Grade A, B et Neuves.",
  video_reliable: "Livraison Fiable",
  video_reliable_desc: "Nous livrons dans tout Anvers et la Belgique avec des délais rapides.",

  why_title: "Pourquoi Choisir PEL Partner ?",
  why1_title: "Qualité Certifiée",
  why1_desc: "Palettes certifiées EPAL, chaque lot inspecté selon les normes européennes.",
  why2_title: "Prix Compétitifs",
  why2_desc: "Meilleurs prix à Anvers pour les palettes Grade A, B et neuves.",
  why3_title: "Délai Rapide",
  why3_desc: "Traitement rapide des commandes et livraison en Belgique.",
  why4_title: "Partenaire Fiable",
  why4_desc: "Relations à long terme basées sur la confiance et la qualité.",

  delivery_label: "Nous Livrons dans Toute la Belgique",
  delivery_title: "Nos Zones de Service",
  delivery_subtitle: "Livraison rapide et fiable dans les principales villes de Belgique et d'Europe.",

  faq_label: "Questions Fréquentes",
  faq_title: "Questions Fréquemment Posées",
  faq_subtitle: "Trouvez des réponses aux questions les plus courantes sur nos palettes, services et processus de commande.",
  faq_q1: "Quels grades de palettes proposez-vous ?",
  faq_a1: "Nous proposons trois grades : Grade A (palettes usagées premium en excellent état), Grade B (palettes usagées économiques avec légère usure) et Palettes en Bois Neuves (neuves, certifiées ISPM15 pour l'export).",
  faq_q2: "Quelle est la quantité minimale de commande ?",
  faq_a2: "Nous traitons des commandes de toutes tailles, des petites quantités aux commandes en gros. Contactez-nous pour discuter de vos besoins.",
  faq_q3: "Dans quelles zones livrez-vous ?",
  faq_a3: "Nous livrons dans toute la Belgique, y compris Anvers, Bruxelles, Gand, Bruges et Liège. Nous servons également des clients dans toute l'Europe.",
  faq_q4: "Quels sont vos délais de livraison ?",
  faq_a4: "Les palettes usagées Grade A et B sont généralement en stock et disponibles pour livraison immédiate. Les palettes neuves peuvent nécessiter 1-2 semaines.",
  faq_q5: "Vos palettes sont-elles certifiées EPAL ?",
  faq_a5: "Oui, nos palettes Grade A sont certifiées et estampillées EPAL. Toutes les palettes neuves sont traitées thermiquement ISPM15.",
  faq_q6: "Proposez-vous des tailles de palettes personnalisées ?",
  faq_a6: "Oui, nous pouvons fabriquer des palettes en bois neuves aux dimensions personnalisées. La taille standard EUR/EPAL est 1200 × 800 mm.",
  faq_q7: "Comment assurez-vous la qualité des palettes ?",
  faq_a7: "Chaque palette est inspectée manuellement par notre personnel formé. Nous vérifions l'intégrité structurelle et la conformité EPAL.",
  faq_q8: "Quels modes de paiement acceptez-vous ?",
  faq_a8: "Nous acceptons les virements bancaires, les cartes de crédit et pouvons convenir de conditions de paiement pour les clients établis.",

  contact_label: "Nous Contacter",
  contact_title: "Prenez Contact",
  contact_info_title: "Informations de Contact",
  contact_phone_label: "Téléphone",
  contact_email_label: "E-mail",
  contact_location_label: "Localisation",
  contact_hours_label: "Heures d'Ouverture",
  contact_hours_val: "Lundi – Vendredi : 8:00 – 18:00",
  contact_call_now: "Appeler Maintenant",
  contact_email_us: "Nous Écrire",
  contact_quote_title: "Demander un Devis",
  form_name: "Nom",
  form_phone: "Téléphone",
  form_email: "E-mail",
  form_product: "Produit",
  form_product_placeholder: "Sélectionner un produit...",
  form_product_a: "Palettes Euro Usagées — Grade A",
  form_product_b: "Palettes Euro Usagées — Grade B",
  form_product_new: "Palettes en Bois Neuves",
  form_product_mixed: "Commande Mixte",
  form_message: "Message",
  form_message_placeholder: "Parlez-nous de vos besoins, quantité requise...",
  form_send: "Envoyer la Demande",
  form_sending: "Envoi en cours...",
  form_success_title: "Message Envoyé !",
  form_success_desc: "Nous vous répondrons dès que possible.",
  form_send_another: "Envoyer un Autre",
  form_error: "Une erreur s'est produite. Veuillez réessayer.",

  order_title: "Passer une Commande",
  order_subtitle: "Remplissez vos coordonnées et nous confirmerons votre commande sous 24 heures.",
  order_company: "Nom de l'Entreprise",
  order_company_ph: "Nom de votre entreprise",
  order_contact: "Nom du Contact",
  order_contact_ph: "Votre nom complet",
  order_quantity: "Quantité",
  order_quantity_ph: "Nombre de palettes",
  order_address: "Adresse de Livraison",
  order_address_ph: "Rue, Ville, Code Postal",
  order_date: "Date de Livraison Souhaitée",
  order_notes: "Notes Supplémentaires",
  order_notes_ph: "Exigences spéciales ou questions...",
  order_cancel: "Annuler",
  order_review: "Vérifier la Commande",
  order_summary_title: "Récapitulatif de Commande",
  order_summary_subtitle: "Veuillez vérifier les détails de votre commande avant de soumettre.",
  order_company_info: "Informations sur l'Entreprise",
  order_company_name_label: "Nom de l'Entreprise",
  order_contact_label: "Personne de Contact",
  order_email_label: "E-mail",
  order_phone_label: "Téléphone",
  order_details: "Détails de la Commande",
  order_product_label: "Produit",
  order_qty_label: "Quantité",
  order_qty_unit: "palettes",
  order_address_label: "Adresse de Livraison",
  order_date_label: "Date Souhaitée",
  order_notes_label: "Notes Supplémentaires",
  order_next_steps: "Prochaines Étapes :",
  order_next_steps_desc: "Après soumission, notre équipe examinera votre commande et vous contactera sous 24 heures.",
  order_edit: "Modifier la Commande",
  order_confirm: "Confirmer & Soumettre",
  order_submitting: "Soumission de votre commande...",
  order_submitting_desc: "Veuillez patienter un moment.",
  order_success_title: "Commande Soumise avec Succès !",
  order_ref_label: "Numéro de Référence",
  order_success_desc: "Merci pour votre commande ! Nous examinerons votre demande et vous contacterons sous 24 heures.",
  order_close: "Fermer",
  order_error: "Une erreur s'est produite. Veuillez réessayer.",

  footer_products: "Produits",
  footer_contact: "Contact",
  footer_copyright: "© 2025 PEL Partner Company. Tous droits réservés.",
  footer_tagline: "Anvers, Belgique — Fournisseur de Palettes Euro",
  footer_desc: "Votre fournisseur de palettes Euro de confiance à Anvers, Belgique. Palettes Grade A, B et neuves — qualité garantie.",

  compare_label: "Comparatif",
  compare_title: "Comparez Nos Grades de Palettes",
  compare_subtitle: "Vous ne savez pas quel grade vous convient ? Comparez les trois options en un coup d'œil.",
  compare_feature: "Caractéristique",
  compare_grade_a: "Grade A",
  compare_grade_b: "Grade B",
  compare_new: "Palettes Neuves",
  compare_condition: "État",
  compare_condition_a: "Excellent — usure minimale",
  compare_condition_b: "Bon — légère usure cosmétique",
  compare_condition_new: "Neuf — jamais utilisé",
  compare_certification: "Certification",
  compare_certification_a: "Certifié EPAL",
  compare_certification_b: "Contrôlé qualité",
  compare_certification_new: "Certifié ISPM15",
  compare_load: "Capacité de Charge",
  compare_load_a: "Jusqu'à 1500 kg",
  compare_load_b: "Jusqu'à 1000 kg",
  compare_load_new: "Jusqu'à 2000 kg",
  compare_export: "Prêt à l'Export",
  compare_export_a: "UE uniquement",
  compare_export_b: "UE uniquement",
  compare_export_new: "Mondial",
  compare_custom: "Tailles Personnalisées",
  compare_custom_a: "Non",
  compare_custom_b: "Non",
  compare_custom_new: "Oui",
  compare_availability: "Disponibilité",
  compare_availability_a: "En Stock",
  compare_availability_b: "En Stock",
  compare_availability_new: "Sur Commande",
  compare_best_for: "Idéal Pour",
  compare_best_for_a: "Alimentaire, marchandises sensibles",
  compare_best_for_b: "Entreposage général",
  compare_best_for_new: "Export & expédition internationale",
  compare_starting_price: "Prix de Départ",
  compare_cta: "Commander",
  compare_yes: "Oui",
  compare_no: "Non",
};

export default translation;
